import { BillableSourceType, useGetBillableConfig, useUpsertBillableConfig } from 'api/billableConfigs';
import {
  useEffect, useState,
} from 'react';


const useFlowsBillable = ({
  crFlowId,
  enabled,
  cleanRoomId,
}) => {
  const [isBillable, setIsBillable] = useState(false);
  const [hasSpecificConfig, setHasSpecificConfig] = useState(false);

  const {
    data: flowBillableConfig,
    isFetching: isBFetching,
    isSuccess,
  } = useGetBillableConfig(
    crFlowId,
    BillableSourceType.BILLABLE_FLOW,
    enabled && !!crFlowId,
  );

  const {
    mutate: upsertFlowBillableConfig,
    isLoading: isBUpserting,
    isSuccess: isBUpserted,
  } = useUpsertBillableConfig();

  // Get cleanroom billable config for inheritance
  const {
    data: cleanRoomBillableConfig,
    isSuccess: isCrSuccess,
  } = useGetBillableConfig(
    cleanRoomId,
    BillableSourceType.BILLABLE_CR,
    enabled && !!cleanRoomId,
  );

  const saveBillable = () => {
    let shouldCreateConfig = false;

    if (hasSpecificConfig) {
      shouldCreateConfig = true;
    }
    else {
      const inheritedValue = cleanRoomBillableConfig?.value === 'true';
      shouldCreateConfig = isBillable !== inheritedValue;
    }

    if (shouldCreateConfig) {
      const payload = {
        sourceID: crFlowId,
        sourceType: BillableSourceType.BILLABLE_FLOW,
        value: isBillable.toString(),
      };

      // Include ID if updating existing config
      if (flowBillableConfig?.ID) {
        payload.ID = flowBillableConfig.ID;
      }

      upsertFlowBillableConfig(payload);
    }
  };

  useEffect(() => {
    // Only proceed if flow query has completed (either found config or confirmed none exists)
    if (isSuccess) {
      if (flowBillableConfig) {
        // 1. Flow-specific config exists (highest priority)
        setIsBillable(flowBillableConfig.value === 'true');
        setHasSpecificConfig(true);
      }
      else if (isCrSuccess && cleanRoomBillableConfig) {
        // 2. No flow config, but cleanroom config exists (inherit from cleanroom)
        setIsBillable(cleanRoomBillableConfig.value === 'true');
        setHasSpecificConfig(false);
      }
      else if (isCrSuccess) {
        // 3. No flow config and no cleanroom config, default to false
        setIsBillable(false);
        setHasSpecificConfig(false);
      }
    }
  }, [isSuccess, isCrSuccess, flowBillableConfig, cleanRoomBillableConfig]);

  return {
    isBFetching,
    isBUpserting,
    isBUpserted,
    isBillable,
    setIsBillable,
    saveBillable,
    hasSpecificConfig, // Expose this to know if config exists
  };
};

export default useFlowsBillable;
